
























































































import { Component, Vue } from 'vue-property-decorator'
import { CognitoIdentityServiceProvider } from 'aws-sdk'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

@Component
export default class VerifyPhone extends Vue {
  public phoneNumber = ''

  mounted () {
    this.getPhone()
  }

  private async getPhone () {
    let phoneNumber = Vue.$cookies.get('phoneNumber')
    if (phoneNumber.startsWith('+1')) {
      phoneNumber = phoneNumber.replace('+1', '')
    }
    if (!phoneNumber || (phoneNumber.startsWith('+') && !phoneNumber.startsWith('+1'))) {
      console.log('close non us')
      // window.close() // Only US numbers are supported
    }

    phoneNumber = phoneNumber.replace(/\D/gu, '')

    if (phoneNumber.length !== 10) {
      console.log('close 10')
      // window.close() // Only ten-digit phone numbers are supported
    }
    this.phoneNumber = phoneNumber
  }

  public async addPhoneAndSendVerify (): Promise<void> {
    const accessToken = Vue.$cookies.get('accessToken')
    if (!accessToken) {
      throw new Error('No access token found')
    }
    const provider = new CognitoIdentityServiceProvider({ region: 'us-west-2' })
    await new Promise((resolve, reject) => {
      provider.updateUserAttributes({
        UserAttributes: [{
          Name : 'phone_number',
          Value: `+1${this.phoneNumber}`
        }],
        AccessToken   : accessToken
      }, (err, data) => {
        if (err) {
          reject(err)
          return
        }
        resolve(data)
      })
    })
    await new Promise((resolve, reject) => {
      provider.getUserAttributeVerificationCode({
        AccessToken  : accessToken,
        AttributeName: 'phone_number'
      }, (err, data) => {
        if (err) {
          reject(err)
          return
        }
        resolve(data)
      })
    })
    await this.$router.push({
      name  : 'MFA',
      params: {
        phoneNumber: this.phoneNumber
      }
    })
  }
}
